import { cn } from '../../lib/cn';
import type { WiringCheckRow } from '../../enterpriseintegration/framework';

type Props = { checks?: WiringCheckRow[] };

export function ProductionWiringPanel({ checks = [] }: Props) {
  return (
    <div className="space-y-2">
      {checks.map((c) => (
        <div key={c.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{c.name}</p>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              c.status === 'passed'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300',
            )}>
              {c.status} · {c.score}%
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', c.score >= 95 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${c.score}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
